// Running-late detection for the floor. A client is "running late" once the sim
// clock is this many whole minutes past their scheduled start and they still
// have not been checked in. Kept as pure time math (no Booking/status coupling)
// so the floor gates it on its own arriving bucket; "now" is always the
// simulation clock, never Date.now().
export const LATE_THRESHOLD_MIN = 15;

/** Whole minutes the clock is past `startIso`. Negative before the start. */
export function lateMinutes(startIso: string, nowIso: string): number {
  return Math.floor((new Date(nowIso).getTime() - new Date(startIso).getTime()) / 60_000);
}

/** True once the clock is `LATE_THRESHOLD_MIN`+ minutes past the start. */
export function isRunningLate(startIso: string, nowIso: string): boolean {
  return lateMinutes(startIso, nowIso) >= LATE_THRESHOLD_MIN;
}
